import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useLang } from "@/contexts/LanguageContext";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card className="p-8 max-w-md w-full text-center">
        <XCircle className="w-16 h-16 text-destructive mx-auto mb-4" />
        <h1 className="text-2xl font-bold mb-2">{t("paymentCanceled")}</h1>
        <Button onClick={() => navigate("/feed")} className="rounded-full mt-4">Voltar</Button>
      </Card>
    </div>
  );
}
